import React, {useState} from "react";
import { makeStyles } from '@material-ui/core/styles';


import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import ReplyHolder from '../components/ReplyHolder';
import Grid from '@material-ui/core/Grid';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import HashTagHolder from './HashTagHolder';
import UpDownHolder from './UpDownHolder';

const useStyles = makeStyles((theme) => ({
  root: {
      marginBottom: 5,
      paddingBottom: 5,
      borderRadius: 0,
      
  },
  authorinfo:{
      marginBottom: 5,
      paddingLeft: 12, 
      paddingRight: 16,
  },
  comment:{
      paddingTop: 5,
      paddingBottom: 5
  }
}));

export default function CommentHolder(props){
    const comment= props.comment
    const classes=useStyles();
    const [replyshown, setReplyShown] = useState(false);

    const  toggleReply = () =>{
        setReplyShown((replyshown)=> !replyshown);
    }


    return(
        <div>
            <Card className={classes.root}>
                <CardContent className={classes.comment}>
                    <Grid container className={classes.authorinfo}>
                        <Grid item xs={11} style={{display: 'flex', lineHeight: '32px'}} >
                            <Typography gutterBottom variant="body1" component="h2" style={{lineHeight: '32px', fontWeight:'800'}}>
                                {comment.author}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            {comment.username===props.username?    
                                <Button className={classes.input} variant="outlined" style={{display: "flex", border: 0, color: 'palevioletred'}}  onClick={props.deleteFunc}>
                                    <FontAwesomeIcon icon={faTrashAlt} /> 
                                </Button>
                                : null}
                        </Grid>
                    </Grid>
                    <Grid style={{textAlign: 'justify', paddingLeft: '16px', paddingRight: '16px'}}>
                        <Typography variant="body2" color="textPrimary" component="p" style={{ whiteSpace: 'pre-line', textAlign:'justify'}}>
                            {comment.text}   
                        </Typography>
                   </Grid>
                </CardContent>

                {props.condition==='text'?
                    <HashTagHolder hashtags={comment.hashtags} commentId={comment.id} displayname={props.displayname} username={props.username}  changeHashtagVote={props.changeHashtagVote} addHashtag={props.addHashtag}/> 
                    : <UpDownHolder updownvotes={comment.updownvotes} commentId={comment.id} displayname={props.displayname} username={props.username} changeUpDownVote={props.changeUpDownVote}/>
                }

                <CardActions style={{paddingLeft: '30px', paddingRight: '30px', paddingBottom: '0px'}}>
                    <Button size="small" color="primary" onClick={toggleReply}>
                    {comment.replies.length > 0? 
                    <span> {comment.replies.length} Replies ({replyshown? "click to hide" : "click to show"})</span>: <span> 0 Reply (click to reply)</span>
                    }
                    </Button>
                </CardActions>
                {replyshown? 
                <ReplyHolder replies={comment.replies} commentId={comment.id} displayname={props.displayname} username={props.username} addReply={props.addReply} deleteReply={props.deleteReply}/> : null
                }
        </Card>
        </div>
    )
}

